import React from 'react';
import ReactDOM from 'react-dom';
import ModalColetas from "./ModalColetas";

class Execucoes extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            execucoes: [],
            show_modal_dados: false,
            loading: false,
            link: '',
            coletas_showing: []
        }
    }

    componentDidMount = async ()=>{
        await this.getExecucoes();
    }

    setLoading = async (value) => {
        await this.setState({loading: value});
    }

    getExecucoes = async () => {
        try{
            await this.setLoading(true);

            const id = route().params.id;

            const response = await axios.get( route('web.workflow_runs.json', id ) );

            await this.setState({
                ...this.state,
                execucoes: response.data.workflowRuns,
                link: response.data.link
            });

        }catch (error) {
            console.log(error);
        }finally {
            await this.setLoading(false);
        }
    }

    showDataModal = async () => {
        await this.setState({show_modal_dados: true});
    }

    closeDataModal = async () => {
        await this.setState({show_modal_dados: false});
    }




    render(){
        return(
            <div>

                <ModalColetas
                    show={this.state.show_modal_dados}
                    handleClose={this.closeDataModal}
                    coletas={this.state.coletas_showing}
                    ignoreColeta={this.ignoreColeta}
                />

                <h1>Execuções</h1>

                <div style={{overflowY: 'auto'}}>

                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Quantidade de Coletas</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            { this.state.execucoes.map((execucao, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{execucao.executedAtFormatted}</td>
                                        <td>{execucao.data.length}</td>
                                        <td>
                                            <button className="btn btn-primary" onClick={async ()=>{

                                                await this.setState({
                                                    ...this.state,
                                                    coletas_showing: execucao.data
                                                });

                                                await this.showDataModal();
                                            }}>
                                                Ver Dados
                                            </button>
                                        </td>
                                    </tr>
                                );
                            }) }

                        </tbody>
                    </table>

                </div>
            </div>
        );
    }
}

if (document.getElementById('js-workflow-execucoes')) {
    ReactDOM.render(<Execucoes />, document.getElementById('js-workflow-execucoes'));
}
